module.exports = __webpack_public_path__ + "img/icon-mail.16c4f103.svg";